import type { Translation } from "@/types/i18n";
import type { ReadingAge, VitalStatus } from "./homeLogic";
import { fill } from "./fill";

/** A reading's age and status in the traveller's language. */
export function ageText(age: ReadingAge, t: Translation): string {
  switch (age.kind) {
    case "unknown":
      return t.ageUnknown;
    case "today":
      return t.ageToday;
    case "days":
      return fill(t.ageDays, { n: age.n });
    case "months":
      return fill(t.ageMonths, { n: age.n });
    case "years":
      return fill(t.ageYears, { n: age.n });
  }
}

export function statusText(status: VitalStatus, t: Translation): string {
  const words: Record<VitalStatus["key"], string> = {
    low: t.vitalLow,
    normal: t.normal,
    elevated: t.vitalElevated,
    high: t.vitalHigh,
    underweight: t.vitalUnderweight,
    overweight: t.vitalOverweight,
    obese: t.vitalObese,
  };
  return words[status.key];
}
